import React, { useEffect, useState } from 'react';
import { PageContentType } from '../../../../../server/global/enum';
import { PageContainer } from './PageContainer';

export const ContentHomePage = () => {
    return (<PageContainer content_type={PageContentType.HOME} />);
};

export const ContentFrontPage = () => {
    return (<PageContainer content_type={PageContentType.FRONTPAGE} />);
};

export const ContentForSale = () => {
    return (<>
        <PageContainer content_type={PageContentType.FORSALE} />
    </>);
};

export const ContentBrokerPage = () => {
    return (<>
        <PageContainer content_type={PageContentType.BROKER} />
    </>);
};

export const ContentContactPage = () => {
    return (<>
        <PageContainer content_type={PageContentType.CONTACT} />
    </>);
};

export const ContentCustomerPage = () => {
    return (<>
        <PageContainer content_type={PageContentType.CUSTOMER} />
    </>);
};

export const ContentServicePage = () => {
    return (<>
        <PageContainer content_type={PageContentType.SERVICE} />
    </>);
};

export const ContentNews = () => {
    return (<>
        <PageContainer content_type={PageContentType.NEWS} />
    </>);
};

export const ContentBuy = () => {
    return (<>
        <PageContainer content_type={PageContentType.BUY} />
    </>);
};
